/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `live` - live
 * * `in review` - in review
 * * `not live` - not live
 * @export
 */
export const UseCaseStatusEnum = {
  live: 'live',
  inReview: 'in review',
  notLive: 'not live',
} as const;
export type UseCaseStatusEnum = (typeof UseCaseStatusEnum)[keyof typeof UseCaseStatusEnum];

export function instanceOfUseCaseStatusEnum(value: any): boolean {
  for (const key in UseCaseStatusEnum) {
    if (Object.prototype.hasOwnProperty.call(UseCaseStatusEnum, key)) {
      if ((UseCaseStatusEnum as Record<string, UseCaseStatusEnum>)[key] === value) {
        return true;
      }
    }
  }
  return false;
}

export function UseCaseStatusEnumFromJSON(json: any): UseCaseStatusEnum {
  return UseCaseStatusEnumFromJSONTyped(json, false);
}

export function UseCaseStatusEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): UseCaseStatusEnum {
  return json as UseCaseStatusEnum;
}

export function UseCaseStatusEnumToJSON(value?: UseCaseStatusEnum | null): any {
  return value as any;
}
